import { render, staticRenderFns } from "./SessionSortBtn.vue?vue&type=template&id=4cc5daa7&"
import script from "./SessionSortBtn.vue?vue&type=script&lang=ts&"
export * from "./SessionSortBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports